import Vue from 'vue';
import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';

export default {
  namespaced: true,
  state: {
    roles: [],
  },
  mutations: {
    set(state: any, payload: any) {
      state.roles = payload;
    },
    show(state: any, payload: boolean) {
      state.showModal = payload;
    },
  },
  actions: {
    reset({ commit }: {commit: any}): void {
      commit('set', []);
    },
    update({ commit }: {commit: any}): void {
      request('get', `roles` )
      .then((response: AxiosResponse) => {
        commit('set', response.data);
      });
    },
  },
  getters: {
    list: (state: any): object[] => state.roles || [],
  },
};

